import Vue from 'vue'

export default {
  login: function (email, password) {
    let apiDetailPath = '/oauth/ro'
    let data = {
      client_id: Vue.env.authClientID,
      connection: Vue.env.authConnection,
      scope: Vue.env.authScope,
      username: email,
      password: password,
      device: Vue.env.deviceInfo
    }
    return Vue.http.post(Vue.env.authApiPath + apiDetailPath, data, { 'headers': { 'Content-Type': 'application/json' } })
  },
  sendPasswordResetEmail: function (email) {
    let apiDetailPath = '/dbconnections/change_password'
    let data = {
      'client_id': Vue.env.authClientID,
      'connection': Vue.env.authConnection,
      'email': email,
      'device': Vue.env.deviceInfo
    }
    return Vue.http.post(Vue.env.authApiPath + apiDetailPath, data, { 'headers': {'Content-Type': 'application/json'} })
  },
  refreshIdToken: function (refreshToken) {
    let apiDetailPath = '/delegation'
    let data = {
      grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
      scope: Vue.env.authScope,
      client_id: Vue.env.authClientID,
      refresh_token: refreshToken
    }
    return Vue.http.post(Vue.env.authApiPath + apiDetailPath, data, { 'headers': { 'Content-Type': 'application/json' } })
  },
  revokeRefreshToken: function (refreshToken) {
    let apiDetailPath = '/oauth/revoke'
    let data = {
      client_id: Vue.env.authClientID,
      token: refreshToken
    }
    return Vue.http.post(Vue.env.authApiPath + apiDetailPath, data, { 'headers': { 'Content-Type': 'application/json' } })
  },
  getIDTokenIPAuth: function (dealerId, state) {
    let apiDetailPath = '/ipauth/v1/token'
    apiDetailPath += '?response_type=id_token'
    apiDetailPath += '&username=' + dealerId
    apiDetailPath += '&state=' + state
    apiDetailPath += '&client_id=' + Vue.env.ipAuthClientID
    return Vue.http.get(Vue.env.ipAuthAPIPath + apiDetailPath)
  }
}



// WEBPACK FOOTER //
// ./src/apis/auth.js